import { z } from 'zod';

import { getGeneralStaticBuilderSchema } from '~/utils/validation/qrCodeBuilder';

export const getSchema = ({ t }) => {
  return z
    .object({
      authType: z.enum(['WEP', 'WPA', 'WPA2-EAP', 'nopass']),
      hidden: z.boolean(),
      password: z
        .string()
        .trim()
        .max(100, t('errors:max', { count: 100 }))
        .optional(),
      ssid: z
        .string({ message: t('inputs:required') })
        .trim()
        .min(1, t('inputs:required'))
        .max(100, t('errors:max', { count: 100 })),
    })
    .merge(getGeneralStaticBuilderSchema());
};

export const DEFAULT_VALUES = {
  name: '',
  authType: 'WEP',
  hidden: false,
  password: '',
  ssid: '',
};
